module.exports = __webpack_public_path__ + "static/3_2_Bayes-Rule_1_CS-96ed77c10277716d58be15912be91b00.svg";